exports.UnitChargeType = {
  FIXED: "FIXED",
  PER_UNIT: "PER_UNIT",
};
